export const PASSWORD_MIN_LENGTH = 8;

const SPECIAL_CHARACTER_RE = /[^A-Za-z0-9\s]/;

export const PASSWORD_RULES = [
  {
    id: "length",
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: (value) => value.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: "special",
    label: "At least one special character (e.g. !@#$%^&*)",
    test: (value) => SPECIAL_CHARACTER_RE.test(value),
  },
];

export const getPasswordError = (value = "") => {
  const failed = PASSWORD_RULES.find((rule) => !rule.test(value));
  if (!failed) return "";
  return failed.id === "length"
    ? `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`
    : "Password must include at least one special character.";
};
